const surveyTemplates = [
    {
        title: "surveys.details.templateCrisisMgmt",
        questions: [
            "5e8b01a636589f3e4600a9fe",
            "5e8b01a636589f3e4600aa00",
            "5e8b01a636589f3e4600a9fd",
            "5e8b01a636589f3e4600aa02",
            "5e8b01a636589f3e4600a9ff",
            "5e8b01a636589f3e4600a9fc",
            "5e8b01a636589f3e4600aa01",
            "5e8b01a636589f3e4600aa07",
            "5e8b01a636589f3e4600aa08",
            "5e8b01a636589f3e4600aa04",
            "5e8b01a636589f3e4600aa06",
            "5e8b01a636589f3e4600aa03",
            "5e8b01a636589f3e4600aa05",
        ],
    },
    {
        title: "surveys.details.templateEngagement",
        questions: [
            "5a96ac2383262f741c988eee",
            "5a96acab83262f741c9895c4",
            "5ac4b62c83262f741c16a82b",
            "5ac4b61d83262f741c16a7d8",
            "5ac4b60783262f741c16a74e",
            "5ac4b6f983262f741c16afce",
            "5ac4b6eb83262f741c16af6d",
            "5ac4b70b83262f741c16b039",
            "5ac4b89b83262f741c16bc70",
            "5ac4b8b783262f741c16bd79",
            "5ac4b8c583262f741c16be18",
            "5ac4b6c383262f741c16ae5d",
            "5ac4b6d283262f741c16aec3",
            "5ac4b5e883262f741c16a67c",
            "5ac4b5cb83262f741c16a3dc",
            "5ac4b7eb83262f741c16b621",
            "5ac4b7fb83262f741c16b67a",
            "5ac4b7db83262f741c16b5a1",
            "5ac4b64983262f741c16a8f5",
            "5ac4b65783262f741c16a957",
            "5ac4b94983262f741c16c1c4",
            "5ac4b93b83262f741c16c167",
            "5ac4b97583262f741c16c2e3",
            "5ac4b9a883262f741c16c445",
            "5ac4b9bb83262f741c16c4c1",
            "5ac4b99583262f741c16c3c1",
            "5ac4b7c083262f741c16b4e4",
            "5ac4b74a83262f741c16b1ca",
            "5ac4b7a583262f741c16b436",
            "5ac4b86d83262f741c16bb0c",
            "5ac4b85883262f741c16b8f1",
            "5ac4b8ec83262f741c16bf68",
            "5ac4b91383262f741c16c072",
            "5ac4ba1583262f741c16c73e",
            "5ac4ba2683262f741c16c7df",
            "5ac4ba0583262f741c16c6d6",
            "5ac4b6a783262f741c16ad9e",
            "5ac4b67383262f741c16ac42",
            "5ac4b68583262f741c16acbe",
        ],
    },
    {
        title: "surveys.details.templateManagerEff",
        questions: [
            "5ac4b7c083262f741c16b4e4",
            "5ac4b74a83262f741c16b1ca",
            "5ac4b7a583262f741c16b436",
            "5ac4b6eb83262f741c16af6d",
            "5ac4b70b83262f741c16b039",
            "5ac4b97583262f741c16c2e3",
            "5e8b01a636589f3e4600a9ff",
            "5ac4b68583262f741c16acbe",
            "5ac4b91383262f741c16c072",
            "5ac4b8ec83262f741c16bf68",
            "5ac4b61d83262f741c16a7d8",
            "5ac4b60783262f741c16a74e",
        ],
    },
    {
        title: "surveys.details.templateTeamwork",
        questions: [
            "5ac4b89b83262f741c16bc70",
            "5ac4b8b783262f741c16bd79",
            "5ac4b8c583262f741c16be18",
            "5ac4b6d283262f741c16aec3",
            "5ac4b6c383262f741c16ae5d",
            "5ac4b68583262f741c16acbe",
            "5ac4b6a783262f741c16ad9e",
            "5ac4b67383262f741c16ac42",
            "5ac4b9bb83262f741c16c4c1",
            "5ac4b99583262f741c16c3c1",
            "5ac4b9a883262f741c16c445",
        ],
    },
    {
        title: "surveys.details.templateDiversityInclusion",
        questions: [
            "5ef231c019ade3bf7de5c752",
            "5ef231c019ade3bf7de5c753",
            "5ef231c019ade3bf7de5c755",
            "5ef231c019ade3bf7de5c751",
            "5ef231c019ade3bf7de5c754",
            "5ef231c019ade3bf7de5c756",
            "5ef231c019ade3bf7de5c758",
            "5ef231c019ade3bf7de5c75a",
            "5ef231c019ade3bf7de5c759",
            "5ef231c019ade3bf7de5c757",
            "5ef231c019ade3bf7de5c75c",
            "5ef231c019ade3bf7de5c75b",
            "5ef231c019ade3bf7de5c75d",
            "5ef231c019ade3bf7de5c75e",
            "5ef231c019ade3bf7de5c75f",
            "5ef231c019ade3bf7de5c763",
            "5ef231c019ade3bf7de5c760",
            "5ef231c019ade3bf7de5c764",
            "5ef231c019ade3bf7de5c761",
            "5ef231c019ade3bf7de5c762",
        ],
    },
    {
        title: "surveys.details.templateEmployeeOnboarding",
        questions: [
            "608abf376747d5fa28f10fc6",
            "608ac1716ef106bd430fb2e2",
            "608ac17879f3110193988265",
            "608ac17ee9c6bd03052caebc",
            "608ac18561e836a11148daf8",
            "608ac19f64cb6f2df4cf3f37",
            "608ac1a534677c4548e812dd",
            "608ac1acaa8602828d312b94",
            "608ac1b28388be67b96854b4",
        ],
    },
    {
        title: "surveys.details.templateEmployeeOffboarding",
        questions: [
            "608ac478ee7f22d76f84646b",
            "608ac47fd63dc3ea88144966",
            "608ac4aa4963daf46201ff14",
            "608ac4b34dd86e14bdd8d1f8",
            "608ac4bb2b9bb59bc7b8233e",
            "608ac4c5e69981db21bb7c17",
            "608ac4d08deb03786a00e8f2",
            "608ac4d8289b3920326b59f1",
            "608ac4df9418dbc4e1a66533",
            "608ac4e888a1934a77bf2d80",
            "608ac4f007269a651f02e31b",
            "608ac4f88aa3125b77020a55",
            "608ac4ff7ba1dc004dcbc989",
            "608ac507864ee7b722e31715",
            "608ac510618a2f1e4a4e66e2",
            "608ac517f470cd7b925301f6",
        ],
    },
];

export default surveyTemplates;
